import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
  
  
    &:hover,
    &:focus {
      
      transform: translate(-4px, -4px);
     
  
      &:after {
        transform: translate(8px, 8px);
        
      }
  
      .img {
        
        mix-blend-mode: normal;
       
      }
    }
  
    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      transition: var(--transition);
    
    }
  
    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
      
    }
  
    &:before {
      top: 0;
      left: 0;
      mix-blend-mode: screen;
    }
  
    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
  
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'JavaScript (ES6+)',
    'TypeScript',
    'React',
    'Angular',
    'Node.js',
    'Next.js',
    'Java',
    'Spring Boot',
    'Python',
    'Swift',
    'AWS',
    'GCP'

  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello, My name is Anish and I'm a recent graduate from Monash University. My primary
              interests are in Software development and Web development, I enjoy creating websites,
              web applications, mobile applications and more.
            </p>

            <p>
              I’ve had the privilege of working at{' '}
              <a href="https://gaorfid.com/">a RFID company </a>,{' '}
              <a href="https://www.monashcav.com/">a vehicle automation team</a>,{' '}
              <a href="https://actionit.dev/">an IT consultancy supporting NGOs</a>,{' '}
              <a href="https://boltinnovate.com/">and a cloud consultancy</a>. On the side, I am
              currently working on updating my iOS app which is currently on the app store and
              various side projects using MERN stack.
            </p>

            <p>Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="./anish.JPG"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF', 'JPG']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

// document.addEventListener('dragstart', function (e) {
//   e.preventDefault();
// });

// Disable opening images in a new tab by clicking with the middle mouse button
// document.addEventListener('mousedown', function (e) {
//   if (e.button === 1) {
//     e.preventDefault();
//   }
// });
// document.addEventListener('contextmenu', function (e) {
//   e.preventDefault();
// });

export default About;
  